module.exports = __webpack_public_path__ + "img/行业应用_新能源汽车.63b7f985.svg";